import { cn } from "src/lib/utils";
import { components } from "src/strapi/schema";
import { strapiRepository } from "src/strapi/strapiRepository";
import { SectionTitle } from "src/components/homepage/section-title";
import BlurFade from "src/components/ui/blur-fade";
import { Link } from "@tanstack/react-router";

export const Services = ({
  servicesTitle,
  services,
}: {
  servicesTitle?: string;
  services?: components["schemas"]["Homepage"]["services"];
}) => {
  if (services === undefined) return null;

  const { getImageUrl } = strapiRepository;

  return (
    <>
      <BlurFade inView>
        <SectionTitle title={servicesTitle ?? "Služby"} />
      </BlurFade>
      {services && (
        <BlurFade inView>
          <div className="flex w-full flex-col gap-2 md:flex-row md:gap-0">
            {services.map((service, index) => {
              if (!service.photo) return null;

              return (
                <Link
                  key={index}
                  to={`/sluzby`}
                  hash={service.category?.slug}
                  className={cn(
                    "group relative h-80 transition-all duration-300 ease-in-out",
                    {
                      "md:w-full": services.length === 1,
                      "md:w-1/2": services.length === 2,
                      "md:w-1/3 md:hover:w-1/2": services.length === 3,
                      "md:w-1/4 md:hover:w-1/2": services.length === 4,
                      "md:w-1/5 md:hover:w-1/3": services.length === 5,
                      "md:w-1/6 md:hover:w-1/3": services.length === 6,
                      "md:w-[14.285714%] md:hover:w-1/3": services.length === 7,
                      "md:w-[12.5%] md:hover:w-1/4": services.length === 8,
                      "md:w-[11.11111%] md:hover:w-1/4": services.length === 9,
                      "md:w-[10%] md:hover:w-1/4": services.length === 10,
                      "md:w-[9.0909%] md:hover:w-1/4": services.length === 11,
                    },
                  )}
                >
                  <div
                    className="md:group-hover:bg-opacity-0 absolute size-full brightness-[70%] ease-in-out md:brightness-[50%] md:group-hover:brightness-95"
                    style={{
                      background: `url(${getImageUrl(service.photo, "medium")}) no-repeat center`,
                      backgroundSize: "cover",
                    }}
                  />
                  <div
                    className={
                      "relative mx-auto flex h-full w-min flex-col justify-center gap-4 text-center"
                    }
                  >
                    <h3
                      className={
                        "bg-foreground/0 text-background md:group-hover:bg-foreground/70 origin-center transform p-2 text-center text-2xl font-semibold brightness-100 transition-all duration-300 md:group-hover:text-3xl md:group-hover:backdrop-blur"
                      }
                    >
                      {service.category?.name}
                    </h3>
                  </div>
                </Link>
              );
            })}
          </div>
        </BlurFade>
      )}
    </>
  );
};
